module.exports = __webpack_public_path__ + "ro.svg?b091db3bf85fd316caa80e5b05cf264a";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ro.svg
// module id = 1331
// module chunks = 0